module.exports = __webpack_public_path__ + "img/logo-colored.9907a20b.png";